import { ButtonProps, Button as AntdButton, Tooltip } from "antd";
import React from "react";

export type { ButtonProps };

export function Button({ className, ...restProps }: ButtonProps) {
  return <AntdButton {...restProps} className={className} />;
}

interface IconButtonProps extends Omit<ButtonProps, "icon"> {
  children: React.ReactNode;
  onClick?: () => void;
  tooltip?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  shape?: "circle" | "round";
}

export const IconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  tooltip,
  disabled = false,
  style,
  size = "middle",
  shape = "circle",
}) => {
  const button = (
    <Button
      type="default"
      icon={children}
      onClick={onClick}
      disabled={disabled}
      style={style}
      size={size}
      shape={shape}
    />
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};
